/* Mirenae — panier : lignes enrichies, format monétaire espagnol, chrono de réservation.
   Purement d'affichage : ne touche ni au contenu du panier ni aux remises.

   L'ancre n'utilise PAS compare_at_price : le contexte marché Espagne le renvoie à null.
   On la calcule comme le bloc offre : prix du flacon seul x nombre de frascos du pack.
   C'est aussi la formulation juste au regard de la loi espagnole (prix de référence =
   achat à l'unité, pas un ancien prix pratiqué). */
(function () {
  if (window.__mct2) return;
  window.__mct2 = 1;

  var TAG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
    '<path d="M21.4 11.6 12.4 2.6A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .6 1.4l9 9a2 2 0 0 0 2.8 0l7-7a2 2 0 0 0 0-2.8ZM6.5 8A1.5 1.5 0 1 1 8 6.5 1.5 1.5 0 0 1 6.5 8Z"/></svg>';

  var LOADED = {};    // handle -> promesse
  var VARIANTS = {};  // id variante -> { t: titre, u: prix unitaire du flacon seul }
  var busy = false;
  var timer = null;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function frascos(title) {
    if (!title) return 0;
    var paid = /(\d+)\s*frascos?/i.exec(title);
    var free = /\+\s*(\d+)\s*GRATIS/i.exec(title);
    return (paid ? +paid[1] : 0) + (free ? +free[1] : 0);
  }

  function dias(title) {
    var m = /(\d+)\s*d[ií]as?/i.exec(title || '');
    return m ? +m[1] : 0;
  }

  /* « 90 días — 2 frascos + 1 GRATIS » -> « 2 frascos + 1 GRATIS » */
  function detail(title) {
    var parts = String(title || '').split(/\s*[—–]\s*/);
    return (parts.length > 1 ? parts.slice(1).join(' — ') : '').trim();
  }

  /* Le réglage boutique est « €{{amount}} » (format anglo-saxon). En Espagne le symbole se
     place APRèS le montant. On corrige à l'affichage dans le panier, sinon nos prix injectés
     (« 74,70 € ») cohabitent avec ceux du thème (« €49,80 ») sur la même ligne.
     Le vrai correctif reste à faire dans Admin > Paramètres > Général > Devise. */
  function normalizeMoney() {
    var roots = document.querySelectorAll('cart-items-component, .cart-drawer, .cart-page, .cart-totals');
    Array.prototype.forEach.call(roots, function (root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (t) {
        var s = t.nodeValue;
        if (!s || s.indexOf('€') < 0) return;
        var out = s.replace(/€\s?(\d[\d.,]*)/g, '$1 €').replace(/\s*\bEUR\b/g, '');
        if (out !== s) t.nodeValue = out;
      });
    });
  }

  function loadProduct(handle) {
    if (!handle) return Promise.resolve();
    if (LOADED[handle]) return LOADED[handle];
    LOADED[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        // prix d'un flacon seul = variante à 1 frasco, sinon la moins chère
        var unit = 0;
        vs.forEach(function (v) { if (frascos(v.title) === 1) unit = v.price; });
        if (!unit) vs.forEach(function (v) { if (!unit || v.price < unit) unit = v.price; });
        vs.forEach(function (v) { VARIANTS[String(v.id)] = { t: v.title || '', u: unit }; });
      })
      .catch(function () { /* produit injoignable : on garde le rendu natif */ });
    return LOADED[handle];
  }

  function decorate(cart) {
    busy = true;

    var byKey = {};
    (cart.items || []).forEach(function (i) { byKey[i.key] = i; });

    var rows = [].slice.call(document.querySelectorAll('.cart-items__table-row[data-key]'));

    rows.forEach(function (row) {
      var item = byKey[row.getAttribute('data-key')];
      if (!item) return;

      // la décoration doit être rejouable : on repart d'une ligne propre
      row.querySelectorAll('.mct2-add').forEach(function (n) { n.remove(); });
      row.classList.remove('mct2-gift', 'mct2-pack', 'mct2-q1');
      if (item.quantity === 1) row.classList.add('mct2-q1');

      var col = row.querySelector('.cart-items__price');   // colonne de droite
      var title = row.querySelector('.cart-items__title');
      var info = row.querySelector('.cart-items__product-info') || (title && title.parentNode);
      if (col) col.classList.add('mct2-col');

      // ---- cadeau : prix final à 0 ----
      if (item.final_price === 0) {
        row.classList.add('mct2-gift');
        if (col) {
          var t = col.querySelector('text-component') || col;
          if (/0,00/.test(t.textContent)) {
            t.textContent = 'GRATIS';
            t.classList.add('mct2-free');
          }
          col.insertAdjacentHTML('afterbegin', '<s class="mct2-add mct2-was">' + money(item.original_price) + '</s>');
          col.insertAdjacentHTML('beforeend', '<span class="mct2-add mct2-save">' + TAG + 'Ahorras 100 %</span>');
        }
        return;
      }

      // ---- pack ----
      var v = VARIANTS[String(item.variant_id)] || {};
      var vt = v.t || item.variant_title || '';
      var n = frascos(vt);
      var d = dias(vt);
      var det = detail(vt);

      if (n > 1 && title) title.setAttribute('data-x', n + 'x');

      if ((d || det) && info) {
        row.classList.add('mct2-pack');
        var html = '';
        if (d) html += '<span class="mct2-add mct2-badge">' + TAG + d + ' días</span>';
        if (det) html += '<span class="mct2-add mct2-meta">' + esc(det).replace(/(\d+\s*GRATIS)/i, '<b>$1</b>') + '</span>';
        info.insertAdjacentHTML('beforeend', html);
      }

      var anchor = (n > 1 && v.u) ? v.u * n : 0;
      if (anchor > item.original_price && col) {
        var saved = (anchor - item.original_price) * item.quantity;
        col.insertAdjacentHTML('afterbegin',
          '<s class="mct2-add mct2-was">' + money(anchor) + '</s>' +
          '<small class="mct2-add mct2-ref">' + n + ' frascos sueltos</small>');
        col.insertAdjacentHTML('beforeend', '<span class="mct2-add mct2-save">' + TAG + 'Ahorras ' + money(saved) + '</span>');
      }
    });

    // Shopify renvoie souvent les cadeaux AVANT le pack : on les redescend dessous.
    rows.forEach(function (row) {
      if (row.classList.contains('mct2-gift') && row.parentNode) row.parentNode.appendChild(row);
    });

    normalizeMoney();

    setTimeout(function () { busy = false; }, 0);
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var handles = {};
          (cart.items || []).forEach(function (i) { if (i.handle) handles[i.handle] = 1; });
          return Promise.all(Object.keys(handles).map(loadProduct)).then(function () { decorate(cart); });
        })
        .catch(function () { /* panier injoignable : on laisse le rendu natif */ });
    }, 60);
  }

  /* ---- chrono de réservation ----
     Le <script> inline du tiroir ne s'exécute pas quand Horizon réinjecte le tiroir en
     innerHTML : le compte à rebours restait figé. On le pilote donc depuis cet asset,
     chargé dans le <head> et donc toujours actif. */
  var KEY = 'mirenae_cart_deadline';

  function deadline(mins) {
    var now = Date.now(), v = null;
    try { v = sessionStorage.getItem(KEY); } catch (e) { /* mode privé */ }
    if (v && +v > now) return +v;
    var d = now + mins * 60000;
    try { sessionStorage.setItem(KEY, d); } catch (e) { /* mode privé */ }
    return d;
  }

  function paintTimer() {
    var els = document.querySelectorAll('.mct-time');
    if (!els.length) return;
    var host = document.querySelector('[data-mct-hold]');
    var mins = host ? (parseInt(host.getAttribute('data-mct-hold'), 10) || 10) : 10;
    var left = Math.max(0, deadline(mins) - Date.now());
    var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
    var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    els.forEach(function (e) { if (e.textContent !== txt) e.textContent = txt; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); paintTimer(); });
  } else {
    refresh();
    paintTimer();
  }
  setInterval(paintTimer, 1000);

  // le tiroir est re-rendu par le thème et par mirenae-offer.js : on repasse derrière
  new MutationObserver(function (muts) {
    if (busy) return;
    for (var i = 0; i < muts.length; i++) {
      var nodes = [].slice.call(muts[i].addedNodes).concat([].slice.call(muts[i].removedNodes));
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (el.nodeType === 1 && !el.classList.contains('mct2-add')) { refresh(); paintTimer(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('cart:update', refresh);
})();
